import { SortDirection } from 'types/enums'

import * as actions from './actions'
import { type IViewLikesContextState } from './types'

export const ViewLikesContextInitialState: IViewLikesContextState = {
    postId: '',
    searchTerm: '',
    sortDirection: SortDirection.ASCENDING,
    ...actions
}
